module.exports = __webpack_public_path__ + "assets/img/Pavillons overlooking Ulu Pandan Road.ad3398bd.jpg";